/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-lights-aurora block)");
/* eslint-enable no-console */
(function () {
    function init() {
        const canvas = document.getElementById('ab-canvas');
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        const wrap = document.getElementById('ab-canvas-wrap');
        const overlay = document.getElementById('ab-overlay');
        const toggleBtn = document.getElementById('ab-toggle');
        const resetBtn = document.getElementById('ab-reset');
        const overlayStart = document.getElementById('ab-overlay-start');
        const fsBtn = document.getElementById('ab-fs-btn');
        const fsExpand = document.getElementById('ab-fs-expand');
        const fsCompress = document.getElementById('ab-fs-compress');
        const paletteEl = document.getElementById('ab-palette');
        const speedEl = document.getElementById('ab-speed');
        const intensityEl = document.getElementById('ab-intensity');
        const bandsEl = document.getElementById('ab-bands');
        const starsEl = document.getElementById('ab-stars');
        const horizonEl = document.getElementById('ab-horizon');

        let running = false, rafId = null, animT = 0, lastTs = null;
        let stars = [], dpr = 1, cw = 0, ch = 0;

        const PALETTES = {
            green: { stops: [[0, '#00ff88'], [.5, '#00cc66'], [1, '#004422']], sky: '#000d05' },
            teal: { stops: [[0, '#00ffcc'], [.5, '#00bbaa'], [1, '#003333']], sky: '#00080a' },
            blue: { stops: [[0, '#44ddff'], [.5, '#0088cc'], [1, '#001833']], sky: '#00040d' },
            purple: { stops: [[0, '#dd88ff'], [.5, '#9933dd'], [1, '#220033']], sky: '#080010' },
            multicolor: { stops: [[0, '#00ff88'], [.33, '#00ccff'], [.66, '#cc66ff'], [1, '#ff6644']], sky: '#020208' },
            pink: { stops: [[0, '#ff99dd'], [.4, '#ff44aa'], [.8, '#cc0077'], [1, '#330022']], sky: '#0d0009' },
            amber: { stops: [[0, '#ffdd88'], [.4, '#ffaa22'], [.8, '#cc6600'], [1, '#2a1000']], sky: '#0a0700' },
            red: { stops: [[0, '#ff6644'], [.4, '#ee2211'], [.8, '#990011'], [1, '#1a0005']], sky: '#0d0002' },
            white: { stops: [[0, '#e8f4ff'], [.4, '#bbddff'], [.8, '#8899bb'], [1, '#223344']], sky: '#040810' },
            deepblue: { stops: [[0, '#0066ff'], [.4, '#0033cc'], [.8, '#001188'], [1, '#000022']], sky: '#000008' },
            magenta: { stops: [[0, '#ff44ff'], [.4, '#cc00cc'], [.8, '#880088'], [1, '#220022']], sky: '#0a000a' },
        };

        const fade = t => t * t * t * (t * (t * 6 - 15) + 10);
        const lrp = (a, b, t) => a + t * (b - a);
        const PERM = (() => {
            const p = Array.from({ length: 256 }, (_, i) => i);
            for (let i = 255; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [p[i], p[j]] = [p[j], p[i]];
            }
            return [...p, ...p];
        })();
        const dot2 = (h, x, y) => {
            const d = h & 3;
            return d === 0 ? x + y : d === 1 ? -x + y : d === 2 ? x - y : -x - y;
        };

        function noise2D(x, y) {
            const X = Math.floor(x) & 255, Y = Math.floor(y) & 255;
            x -= Math.floor(x);
            y -= Math.floor(y);
            const u = fade(x), v = fade(y), a = PERM[X] + Y, b = PERM[X + 1] + Y;
            return lrp(
                lrp(dot2(PERM[a], x, y), dot2(PERM[b], x - 1, y), u),
                lrp(dot2(PERM[a + 1], x, y - 1), dot2(PERM[b + 1], x - 1, y - 1), u),
                v
            );
        }

        function fbm(x, y, oct = 4) {
            let v = 0, amp = .5, freq = 1, max = 0;
            for (let i = 0; i < oct; i++) {
                v += noise2D(x * freq, y * freq) * amp;
                max += amp;
                freq *= 2;
                amp *= .5;
            }
            return v / max;
        }

        function resize() {
            dpr = window.devicePixelRatio || 1;
            cw = wrap.clientWidth;
            ch = wrap.clientHeight;
            if (!cw || !ch) {
                setTimeout(resize, 50);
                return;
            }
            canvas.width = Math.round(cw * dpr);
            canvas.height = Math.round(ch * dpr);
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            buildStars();
        }

        new ResizeObserver(() => resize()).observe(wrap);

        function buildStars() {
            const count = parseInt(starsEl.value), maxY = ch * .10;
            stars = Array.from({ length: count }, () => ({
                x: Math.random() * cw,
                y: Math.random() * maxY,
                r: Math.random() * 1.0 + .2,
                a: Math.random() * .5 + .3,
                freq: Math.random() * 1.5 + .3,
                ph: Math.random() * Math.PI * 2,
            }));
        }

        function shiftBright(hex, f) {
            const r = parseInt(hex.slice(1, 3), 16),
                g = parseInt(hex.slice(3, 5), 16),
                b = parseInt(hex.slice(5, 7), 16),
                c = v => Math.min(255, Math.round(v * f));
            return `rgb(${c(r)},${c(g)},${c(b)})`;
        }

        function hexRGB(hex) {
            return {
                r: parseInt(hex.slice(1, 3), 16),
                g: parseInt(hex.slice(3, 5), 16),
                b: parseInt(hex.slice(5, 7), 16)
            };
        }

        function auroraRGB() {
            const pal = PALETTES[paletteEl.value] || PALETTES.green;
            return hexRGB(pal.stops[0][1]);
        }

        function interpolatePal(stops, t) {
            t = Math.max(0, Math.min(1, t));
            const p = s => [parseInt(s.slice(1, 3), 16), parseInt(s.slice(3, 5), 16), parseInt(s.slice(5, 7), 16)];
            for (let i = 0; i < stops.length - 1; i++) {
                const [t0, c0] = stops[i], [t1, c1] = stops[i + 1];
                if (t >= t0 && t <= t1) {
                    const f = (t - t0) / (t1 - t0), a = p(c0), b = p(c1);
                    return `${Math.round(a[0] + (b[0] - a[0]) * f)},${Math.round(a[1] + (b[1] - a[1]) * f)},${Math.round(a[2] + (b[2] - a[2]) * f)}`;
                }
            }
            const a = p(stops[stops.length - 1][1]);
            return `${a[0]},${a[1]},${a[2]}`;
        }

        function drawSky(pal) {
            const g = ctx.createLinearGradient(0, 0, 0, ch);
            g.addColorStop(0, pal.sky);
            g.addColorStop(.6, shiftBright(pal.sky, 2));
            g.addColorStop(1, shiftBright(pal.sky, 3));
            ctx.fillStyle = g;
            ctx.fillRect(0, 0, cw, ch);
        }

        function drawStars(t) {
            stars.forEach(s => {
                const a = s.a * (.55 + .45 * Math.sin(t * s.freq + s.ph));
                ctx.beginPath();
                ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(255,255,255,${a.toFixed(3)})`;
                ctx.fill();
            });
        }

        function drawAurora(pal, t) {
            const nbands = parseInt(bandsEl.value),
                intens = parseInt(intensityEl.value) / 100,
                spd = parseFloat(speedEl.value),
                cols = Math.ceil(cw / 3);

            for (let b = 0; b < nbands; b++) {
                const baseY = ch * (.05 + (b + .5) / nbands * .80),
                    bandH = ch * (.12 + .10 * Math.sin(b * 1.3)),
                    col = interpolatePal(pal.stops, b / Math.max(nbands - 1, 1));

                for (let cx2 = 0; cx2 < cols; cx2++) {
                    const nx = (cx2 / cols) * 4,
                        nt = t * spd * .18,
                        wY = fbm(nx + nt, b * 2.7, 4) * ch * .08,
                        pulse = (fbm(nx * .5 + nt * .7, b * 1.1 + 10, 3) + 1) * .5,
                        alpha = pulse * intens * (.6 + .3 * Math.sin(t * spd * .4 + b + cx2 * .03)),
                        cY = baseY + wY,
                        colW = Math.ceil(cw / cols) + 1;

                    const g = ctx.createLinearGradient(0, cY - bandH * 1.2, 0, cY + bandH * 2.8);
                    g.addColorStop(0, `rgba(${col},0)`);
                    g.addColorStop(.15, `rgba(${col},${(alpha * .3).toFixed(3)})`);
                    g.addColorStop(.40, `rgba(${col},${alpha.toFixed(3)})`);
                    g.addColorStop(.65, `rgba(${col},${(alpha * .45).toFixed(3)})`);
                    g.addColorStop(.85, `rgba(${col},${(alpha * .12).toFixed(3)})`);
                    g.addColorStop(1, `rgba(${col},0)`);
                    ctx.fillStyle = g;
                    ctx.fillRect((cx2 / cols) * cw, cY - bandH * 1.2, colW, bandH * 4);
                }

                const rc = Math.floor(8 + b * 3);
                for (let r = 0; r < rc; r++) {
                    const rx = (r / rc + fbm(r * .5 + t * spd * .1, b * 3, 2) * .06) * cw,
                        rh = ch * (.10 + .15 * ((fbm(r * 1.1 + t * spd * .15, b * 2, 2) + 1) * .5)),
                        ra = intens * .15 * ((fbm(r * .8 + t * spd * .2, b * 1.5 + 5, 2) + 1) * .5),
                        rY = baseY + fbm(r * .4 + t * spd * .12, b * 2.2, 3) * ch * .08;

                    const rg = ctx.createLinearGradient(0, rY, 0, rY + rh);
                    rg.addColorStop(0, `rgba(${col},${ra.toFixed(3)})`);
                    rg.addColorStop(.5, `rgba(${col},${(ra * .4).toFixed(3)})`);
                    rg.addColorStop(1, `rgba(${col},0)`);
                    ctx.fillStyle = rg;
                    ctx.fillRect(rx - 1.5, rY, 3, rh);
                }
            }
        }

        function drawMountains() {
            ctx.save();
            const farY = ch * .55;
            const fp = [[0, .82], [.07, .62], [.14, .74], [.22, .55], [.29, .68], [.37, .48], [.44, .62], [.51, .52], [.58, .65], [.66, .44], [.73, .60], [.80, .50], [.87, .63], [.94, .53], [1, .70]];
            ctx.beginPath();
            ctx.moveTo(0, ch);
            fp.forEach(([x, y]) => ctx.lineTo(x * cw, farY * (y * .9 + .05)));
            ctx.lineTo(cw, ch);
            ctx.closePath();
            const gFar = ctx.createLinearGradient(0, ch * .38, 0, ch);
            gFar.addColorStop(0, '#0d1f18');
            gFar.addColorStop(.5, '#0a1812');
            gFar.addColorStop(1, '#060e0a');
            ctx.fillStyle = gFar;
            ctx.fill();

            fp.forEach(([x, y], i) => {
                if (y < .58 && i > 0 && i < fp.length - 1) {
                    const px = x * cw, py = farY * (y * .9 + .05);
                    ctx.beginPath();
                    ctx.moveTo(px, py);
                    ctx.lineTo(px - cw * .018, py + ch * .022);
                    ctx.lineTo(px + cw * .018, py + ch * .022);
                    ctx.closePath();
                    const gs = ctx.createLinearGradient(0, py, 0, py + ch * .022);
                    gs.addColorStop(0, 'rgba(225,238,233,0.70)');
                    gs.addColorStop(1, 'rgba(0,0,0,0)');
                    ctx.fillStyle = gs;
                    ctx.fill();
                }
            });

            ctx.beginPath();
            ctx.moveTo(0, ch);
            ctx.lineTo(0, ch * .70);
            ctx.bezierCurveTo(cw * .05, ch * .58, cw * .10, ch * .65, cw * .16, ch * .60);
            ctx.bezierCurveTo(cw * .22, ch * .55, cw * .25, ch * .48, cw * .30, ch * .45);
            ctx.bezierCurveTo(cw * .35, ch * .42, cw * .39, ch * .52, cw * .44, ch * .57);
            ctx.bezierCurveTo(cw * .50, ch * .63, cw * .56, ch * .54, cw * .62, ch * .50);
            ctx.bezierCurveTo(cw * .68, ch * .46, cw * .72, ch * .40, cw * .76, ch * .38);
            ctx.bezierCurveTo(cw * .80, ch * .36, cw * .84, ch * .44, cw * .88, ch * .50);
            ctx.bezierCurveTo(cw * .93, ch * .57, cw * .97, ch * .62, cw, ch * .65);
            ctx.lineTo(cw, ch);
            ctx.closePath();
            const gMid = ctx.createLinearGradient(0, ch * .35, 0, ch);
            gMid.addColorStop(0, '#0a1a10');
            gMid.addColorStop(.5, '#071208');
            gMid.addColorStop(1, '#040c05');
            ctx.fillStyle = gMid;
            ctx.fill();

            [[.30, .45], [.76, .38]].forEach(([px, py]) => {
                const x = px * cw, y = py * ch;
                ctx.beginPath();
                ctx.moveTo(x, y);
                ctx.lineTo(x - cw * .034, y + ch * .038);
                ctx.lineTo(x + cw * .034, y + ch * .038);
                ctx.closePath();
                const gs = ctx.createLinearGradient(0, y, 0, y + ch * .038);
                gs.addColorStop(0, 'rgba(238,248,243,0.92)');
                gs.addColorStop(.55, 'rgba(200,225,215,0.55)');
                gs.addColorStop(1, 'rgba(0,0,0,0)');
                ctx.fillStyle = gs;
                ctx.fill();
            });

            ctx.beginPath();
            ctx.moveTo(0, ch);
            ctx.lineTo(0, ch * .82);
            ctx.bezierCurveTo(cw * .08, ch * .74, cw * .18, ch * .80, cw * .28, ch * .76);
            ctx.bezierCurveTo(cw * .38, ch * .72, cw * .45, ch * .68, cw * .52, ch * .71);
            ctx.bezierCurveTo(cw * .60, ch * .75, cw * .68, ch * .70, cw * .76, ch * .73);
            ctx.bezierCurveTo(cw * .84, ch * .76, cw * .92, ch * .80, cw, ch * .78);
            ctx.lineTo(cw, ch);
            ctx.closePath();
            ctx.fillStyle = '#030b05';
            ctx.fill();
            const sf = ctx.createLinearGradient(0, ch * .78, 0, ch);
            sf.addColorStop(0, 'rgba(195,220,210,0.22)');
            sf.addColorStop(.18, 'rgba(0,0,0,0)');
            ctx.fillStyle = sf;
            ctx.fillRect(0, ch * .78, cw, ch * .22);
            ctx.restore();
        }

        function drawSapin(x, base, th, tw, r, g, b) {
            ctx.fillStyle = `rgb(${r},${g},${b})`;
            ctx.beginPath();
            ctx.moveTo(x, base - th);
            ctx.lineTo(x - tw * .58, base - th * .36);
            ctx.lineTo(x + tw * .58, base - th * .36);
            ctx.closePath();
            ctx.fill();

            ctx.beginPath();
            ctx.moveTo(x, base - th * 1.44);
            ctx.lineTo(x - tw * .44, base - th * .60);
            ctx.lineTo(x + tw * .44, base - th * .60);
            ctx.closePath();
            ctx.fill();

            ctx.beginPath();
            ctx.moveTo(x, base - th * 1.78);
            ctx.lineTo(x - tw * .30, base - th * 1.05);
            ctx.lineTo(x + tw * .30, base - th * 1.05);
            ctx.closePath();
            ctx.fill();

            ctx.fillRect(x - tw * .09, base - th * .36, tw * .18, th * .36);
        }

        function drawForest() {
            ctx.save();
            const { r, g, b } = auroraRGB(), groundY = ch * .82;
            const sr = Math.min(255, Math.round(r * .12 + 172)),
                sg = Math.min(255, Math.round(g * .12 + 190)),
                sb = Math.min(255, Math.round(b * .10 + 180));

            const gGround = ctx.createLinearGradient(0, groundY, 0, ch);
            gGround.addColorStop(0, `rgb(${sr},${sg},${sb})`);
            gGround.addColorStop(.12, `rgb(${Math.round(sr * .38)},${Math.round(sg * .40)},${Math.round(sb * .38)})`);
            gGround.addColorStop(.5, 'rgb(14,22,16)');
            gGround.addColorStop(1, 'rgb(6,10,7)');
            ctx.fillStyle = gGround;
            ctx.fillRect(0, groundY, cw, ch - groundY);

            const gRef = ctx.createLinearGradient(0, groundY, 0, groundY + ch * .05);
            gRef.addColorStop(0, `rgba(${r},${g},${b},0.10)`);
            gRef.addColorStop(1, `rgba(${r},${g},${b},0)`);
            ctx.fillStyle = gRef;
            ctx.fillRect(0, groundY, cw, ch * .05);

            const back = Math.floor(cw / 30);
            for (let i = 0; i < back; i++) {
                const x = (i + .5) * (cw / back) + Math.sin(i * 1.7) * 5,
                    th = ch * (.08 + .03 * Math.abs(Math.sin(i * 2.1))),
                    tw = th * .34;
                drawSapin(x, groundY, th, tw, 3, 10, 5);
            }

            const front = Math.floor(cw / 16);
            for (let i = 0; i < front; i++) {
                const x = (i + .5) * (cw / front),
                    th = ch * (.15 + .07 * Math.abs(Math.sin(i * 2.5))),
                    tw = th * .40;
                drawSapin(x, groundY, th, tw, 2, 8, 4);
            }

            ctx.restore();
        }

        function drawSnow() {
            ctx.save();
            const { r, g, b } = auroraRGB(), baseY = ch * .78;
            const gHaze = ctx.createLinearGradient(0, baseY - ch * .05, 0, baseY + ch * .02);
            gHaze.addColorStop(0, 'rgba(0,0,0,0)');
            gHaze.addColorStop(1, `rgba(${Math.round(r * .08 + 18)},${Math.round(g * .10 + 26)},${Math.round(b * .08 + 20)},0.30)`);
            ctx.fillStyle = gHaze;
            ctx.fillRect(0, baseY - ch * .05, cw, ch * .07);

            for (let layer = 0; layer < 3; layer++) {
                const ly = baseY + layer * ch * .055, amp = ch * (.010 + layer * .007);
                ctx.beginPath();
                ctx.moveTo(0, ch);
                ctx.lineTo(0, ly);
                for (let x = 0; x <= cw; x += 4) {
                    ctx.lineTo(
                        x,
                        ly + Math.sin(x * .007 + layer * 2.1) * amp +
                        Math.sin(x * .019 + layer) * amp * .4 +
                        fbm(x * .003 + layer, layer * 3, 2) * amp * .8
                    );
                }
                ctx.lineTo(cw, ch);
                ctx.closePath();

                const bright = [.92, .72, .50][layer];
                const nr = Math.min(255, Math.round(r * .18 + bright * 198)),
                    ng = Math.min(255, Math.round(g * .18 + bright * 215)),
                    nb2 = Math.min(255, Math.round(b * .16 + bright * 208));

                const gs = ctx.createLinearGradient(0, ly, 0, ch);
                gs.addColorStop(0, `rgb(${nr},${ng},${nb2})`);
                gs.addColorStop(.45, `rgb(${Math.round(bright * 55 + r * .05)},${Math.round(bright * 72 + g * .05)},${Math.round(bright * 60 + b * .05)})`);
                gs.addColorStop(1, 'rgb(5,10,6)');
                ctx.fillStyle = gs;
                ctx.fill();
            }

            const gAuRef = ctx.createLinearGradient(0, baseY, 0, baseY + ch * .09);
            gAuRef.addColorStop(0, `rgba(${r},${g},${b},0.16)`);
            gAuRef.addColorStop(1, `rgba(${r},${g},${b},0)`);
            ctx.fillStyle = gAuRef;
            ctx.fillRect(0, baseY, cw, ch * .09);

            ctx.strokeStyle = 'rgba(255,255,255,0.08)';
            ctx.lineWidth = 1;
            for (let s = 0; s < 7; s++) {
                const sy = baseY + ch * (.035 + s * .022);
                ctx.beginPath();
                ctx.moveTo(cw * .05, sy);
                ctx.bezierCurveTo(cw * .25, sy - ch * .006, cw * .55, sy + ch * .004, cw * .90, sy - ch * .003);
                ctx.stroke();
            }
            ctx.restore();
        }

        function drawCabin() {
            ctx.save();
            const { r, g, b } = auroraRGB(), groundY = ch * .72;
            const sr = Math.min(255, Math.round(r * .16 + 168)),
                sg = Math.min(255, Math.round(g * .16 + 185)),
                sb = Math.min(255, Math.round(b * .14 + 175));

            const gGround = ctx.createLinearGradient(0, groundY, 0, ch);
            gGround.addColorStop(0, `rgb(${sr},${sg},${sb})`);
            gGround.addColorStop(.10, `rgb(${Math.round(sr * .38)},${Math.round(sg * .40)},${Math.round(sb * .38)})`);
            gGround.addColorStop(.5, 'rgb(14,22,16)');
            gGround.addColorStop(1, 'rgb(5,10,6)');
            ctx.fillStyle = gGround;
            ctx.fillRect(0, groundY, cw, ch - groundY);

            const gRef = ctx.createLinearGradient(0, groundY, 0, groundY + ch * .06);
            gRef.addColorStop(0, `rgba(${r},${g},${b},0.12)`);
            gRef.addColorStop(1, 'rgba(0,0,0,0)');
            ctx.fillStyle = gRef;
            ctx.fillRect(0, groundY, cw, ch * .06);

            ctx.beginPath();
            ctx.moveTo(0, ch);
            ctx.lineTo(0, groundY - ch * .05);
            ctx.bezierCurveTo(cw * .15, groundY - ch * .13, cw * .35, groundY - ch * .07, cw * .50, groundY - ch * .09);
            ctx.bezierCurveTo(cw * .65, groundY - ch * .11, cw * .82, groundY - ch * .05, cw, groundY - ch * .03);
            ctx.lineTo(cw, ch);
            ctx.closePath();
            ctx.fillStyle = 'rgb(4,12,6)';
            ctx.fill();

            const back = Math.floor(cw / 24);
            for (let i = 0; i < back; i++) {
                const x = (i + .5) * (cw / back);
                if (x < cw * .34 || x > cw * .68) {
                    const th = ch * (.09 + .04 * Math.abs(Math.sin(i * 2.2))),
                        tw = th * .35;
                    drawSapin(x, groundY, th, tw, 3, 10, 5);
                }
            }

            [[.07, .16, .40], [.15, .14, .38], [.81, .15, .40], [.89, .13, .37]].forEach(([bx, bh, tw]) => {
                const x = bx * cw, th = ch * bh;
                drawSapin(x, groundY, th, th * tw, 2, 8, 4);

                const tipY = groundY - th * 1.78, snowW = th * tw * .22, snowH = ch * .016;
                const gSnow = ctx.createLinearGradient(0, tipY, 0, tipY + snowH);
                gSnow.addColorStop(0, `rgba(${sr},${sg},${sb},0.60)`);
                gSnow.addColorStop(1, 'rgba(0,0,0,0)');
                ctx.fillStyle = gSnow;
                ctx.beginPath();
                ctx.moveTo(x, tipY);
                ctx.lineTo(x - snowW, tipY + snowH);
                ctx.lineTo(x + snowW, tipY + snowH);
                ctx.closePath();
                ctx.fill();
            });

            const cabW = cw * .13, cabH = ch * .115, cabX = cw * .435, cabY = groundY - cabH;
            const gWall = ctx.createLinearGradient(cabX, cabY, cabX, cabY + cabH);
            gWall.addColorStop(0, 'rgb(38,20,11)');
            gWall.addColorStop(1, 'rgb(18,9,4)');
            ctx.fillStyle = gWall;
            ctx.fillRect(cabX, cabY, cabW, cabH);

            ctx.strokeStyle = 'rgba(10,4,1,0.55)';
            ctx.lineWidth = 1.2;
            for (let row = 1; row < Math.floor(cabH / 5.5); row++) {
                ctx.beginPath();
                ctx.moveTo(cabX, cabY + row * 5.5);
                ctx.lineTo(cabX + cabW, cabY + row * 5.5);
                ctx.stroke();
            }

            const roofPeakY = cabY - ch * .058;
            ctx.beginPath();
            ctx.moveTo(cabX - cw * .010, cabY);
            ctx.lineTo(cabX + cabW * .50, roofPeakY);
            ctx.lineTo(cabX + cabW + cw * .010, cabY);
            ctx.closePath();
            ctx.fillStyle = 'rgb(16,8,4)';
            ctx.fill();

            ctx.beginPath();
            ctx.moveTo(cabX - cw * .010, cabY);
            ctx.lineTo(cabX + cabW * .50, roofPeakY - ch * .003);
            ctx.lineTo(cabX + cabW + cw * .010, cabY);
            ctx.lineTo(cabX + cabW + cw * .012, cabY + ch * .006);
            ctx.lineTo(cabX - cw * .012, cabY + ch * .006);
            ctx.closePath();
            const gSnowRoof = ctx.createLinearGradient(0, roofPeakY, 0, cabY + ch * .006);
            gSnowRoof.addColorStop(0, `rgb(${sr},${sg},${sb})`);
            gSnowRoof.addColorStop(.5, `rgba(${sr},${sg},${sb},0.55)`);
            gSnowRoof.addColorStop(1, `rgba(${sr},${sg},${sb},0.10)`);
            ctx.fillStyle = gSnowRoof;
            ctx.fill();

            const winX = cabX + cabW * .14, winY = cabY + cabH * .20, winW = cabW * .30, winH = cabH * .38;
            const gHalo = ctx.createRadialGradient(winX + winW * .5, winY + winH * .5, 0, winX + winW * .5, winY + winH * .5, cw * .06);
            gHalo.addColorStop(0, 'rgba(255,190,70,0.20)');
            gHalo.addColorStop(1, 'rgba(0,0,0,0)');
            ctx.fillStyle = gHalo;
            ctx.fillRect(winX - cw * .05, winY - ch * .04, winW + cw * .10, winH + ch * .08);

            const gWin = ctx.createLinearGradient(0, winY, 0, winY + winH);
            gWin.addColorStop(0, 'rgb(255,228,120)');
            gWin.addColorStop(1, 'rgb(240,165,52)');
            ctx.fillStyle = gWin;
            ctx.fillRect(winX, winY, winW, winH);

            ctx.strokeStyle = 'rgba(14,7,2,0.65)';
            ctx.lineWidth = 1.5;
            ctx.beginPath();
            ctx.moveTo(winX + winW * .5, winY);
            ctx.lineTo(winX + winW * .5, winY + winH);
            ctx.stroke();

            ctx.beginPath();
            ctx.moveTo(winX, winY + winH * .5);
            ctx.lineTo(winX + winW, winY + winH * .5);
            ctx.stroke();

            const doorW = cabW * .22, doorH = cabH * .46, doorX = cabX + cabW * .62, doorY2 = cabY + cabH - doorH;
            ctx.fillStyle = 'rgb(10,5,2)';
            ctx.fillRect(doorX, doorY2, doorW, doorH);
            ctx.strokeStyle = 'rgba(30,15,6,0.50)';
            ctx.lineWidth = 1;
            ctx.strokeRect(doorX, doorY2, doorW, doorH);

            const chimX = cabX + cabW * .70, chimW = cabW * .09;
            ctx.fillStyle = 'rgb(20,10,5)';
            ctx.fillRect(chimX, roofPeakY - ch * .028, chimW, ch * .058);
            ctx.fillStyle = `rgba(${sr},${sg},${sb},0.70)`;
            ctx.fillRect(chimX - 1, roofPeakY - ch * .028, chimW + 2, ch * .007);

            for (let s = 0; s < 5; s++) {
                const sm = s / 5,
                    sx = chimX + chimW * .5 + Math.sin(animT * .9 + s * 1.1) * cw * .010,
                    sy = roofPeakY - ch * .030 - s * ch * .022,
                    srad = cw * (.007 + sm * .014),
                    salpha = Math.max(0, .16 - sm * .13);
                ctx.beginPath();
                ctx.arc(sx, sy, srad, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(165,158,150,${salpha.toFixed(3)})`;
                ctx.fill();
            }

            const gWinSnow = ctx.createRadialGradient(winX + winW * .5, groundY, 0, winX + winW * .5, groundY, cw * .055);
            gWinSnow.addColorStop(0, 'rgba(255,185,65,0.12)');
            gWinSnow.addColorStop(1, 'rgba(0,0,0,0)');
            ctx.fillStyle = gWinSnow;
            ctx.fillRect(winX - cw * .05, groundY, winW + cw * .10, ch * .05);

            ctx.restore();
        }

        function frame(ts) {
            if (!running) return;
            if (lastTs === null) lastTs = ts;
            animT += Math.min((ts - lastTs) / 1000, .05);
            lastTs = ts;

            const pal = PALETTES[paletteEl.value] || PALETTES.green;
            drawSky(pal);
            drawStars(animT);
            drawAurora(pal, animT);

            const h = horizonEl.value;
            if (h === 'mountains') drawMountains();
            else if (h === 'forest') drawForest();
            else if (h === 'snow') drawSnow();
            else if (h === 'cabin') drawCabin();

            rafId = requestAnimationFrame(frame);
        }

        function start() {
            if (running) return;
            running = true;
            lastTs = null;
            overlay.classList.add('ab-hidden');
            toggleBtn.textContent = 'Pause';
            rafId = requestAnimationFrame(frame);
        }

        function pause() {
            running = false;
            if (rafId) cancelAnimationFrame(rafId);
            rafId = null;
            lastTs = null;
            toggleBtn.textContent = 'Resume';
        }

        function reset() {
            animT = 0;
            lastTs = null;
            buildStars();
            overlay.classList.add('ab-hidden');
            if (!running) {
                running = true;
                toggleBtn.textContent = 'Pause';
            }
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(frame);
        }

        toggleBtn.addEventListener('click', () => running ? pause() : start());
        resetBtn.addEventListener('click', reset);
        overlayStart.addEventListener('click', start);
        horizonEl.addEventListener('change', buildStars);

        speedEl.addEventListener('input', () => {
            document.getElementById('ab-speed-val').textContent = speedEl.value;
        });

        intensityEl.addEventListener('input', () => {
            document.getElementById('ab-intensity-val').textContent = `${intensityEl.value}%`;
        });

        bandsEl.addEventListener('input', () => {
            document.getElementById('ab-bands-val').textContent = bandsEl.value;
        });

        starsEl.addEventListener('input', () => {
            document.getElementById('ab-stars-val').textContent = starsEl.value;
            buildStars();
        });

        fsBtn.addEventListener('click', () => {
            if (!document.fullscreenElement) wrap.requestFullscreen().catch(() => { });
            else document.exitFullscreen().catch(() => { });
        });

        document.addEventListener('fullscreenchange', () => {
            const fs = !!document.fullscreenElement;
            fsExpand.style.display = fs ? 'none' : 'block';
            fsCompress.style.display = fs ? 'block' : 'none';
            fsBtn.setAttribute('aria-label', fs ? 'Exit full screen' : 'Full screen');
            wrap.classList.toggle('ab-fullscreen', fs);
            setTimeout(resize, 30);
        });

        resize();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
}());